import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";

import {
  ThemeProvider,
  LoadingBar,
  defaultTheme,
  StoreProvider,
  ControllerProvider,
} from "@searchspring/snap-preact-components";
import { Header } from "../Header/Header";
import { Results, NoResults } from "../Results/Results";
import { FacetState } from "./FacetState";

@observer
export class App extends Component {
  render() {
    const store = this.props.controller.store;

    return (
      <ControllerProvider controller={this.props.controller}>
        <ThemeProvider theme={defaultTheme}>
          <StoreProvider store={store}>
            <div>
              <FacetState store={store} />
            </div>
          </StoreProvider>
        </ThemeProvider>
      </ControllerProvider>
    );
  }
}